import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    postRes: null,
    getRes: null,
    getByIdRes: null,
    searchRes: null,
    putRes: null,
    deleteRes: null,
    formulasRes: null,
};

const slice = createSlice({
    name: 'labTest',
    initialState,
    reducers: {
        postLabTestRequest: (state) => {
            state.loading = true;
        },
        postLabTestSuccess: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        postLabTestFailure: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        resetPostLabTest: (state) => {
            state.postRes = null;
        },

        getLabTestRequest: (state) => {
            state.loading = true;
        },
        getLabTestSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getLabTestFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        resetGetLabTest: (state) => {
            state.getRes = null;
        },

        getLabTestByIdRequest: (state) => {
            state.loading = true;
        },
        getLabTestByIdSuccess: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        getLabTestByIdFailure: (state, action) => {
            state.loading = false;
            state.getByIdRes = action.payload;
        },
        resetGetLabTestById: (state) => {
            state.getByIdRes = null;
        },

        searchLabTestRequest: (state) => {
            state.loading = true;
        },
        searchLabTestSuccess: (state, action) => {
            state.loading = false;
            state.searchRes = action.payload;
        },
        searchLabTestFailure: (state, action) => {
            state.loading = false;
            state.searchRes = action.payload;
        },
        resetSearchLabTest: (state) => {
            state.searchRes = null;
        },

        putLabTestRequest: (state) => {
            state.loading = true;
        },
        putLabTestSuccess: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        putLabTestFailure: (state, action) => {
            state.loading = false;
            state.putRes = action.payload;
        },
        resetPutLabTest: (state) => {
            state.putRes = null;
        },

        deleteLabTestRequest: (state) => {
            state.loading = true;
        },
        deleteLabTestSuccess: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        deleteLabTestFailure: (state, action) => {
            state.loading = false;
            state.deleteRes = action.payload;
        },
        resetDeleteLabTest: (state) => {
            state.deleteRes = null;
        },

        getLabTestFormulasRequest: (state) => {
            state.loading = true;
        },
        getLabTestFormulasSuccess: (state, action) => {
            state.loading = false;
            state.formulasRes = action.payload;
        },
        getLabTestFormulasFailure: (state, action) => {
            state.loading = false;
            state.formulasRes = action.payload;
        },
        resetGetLabTestFormulas: (state) => {
            state.formulasRes = null;
        },
    }
});

export const {
    postLabTestRequest, postLabTestSuccess, postLabTestFailure, resetPostLabTest,
    getLabTestRequest, getLabTestSuccess, getLabTestFailure, resetGetLabTest,
    getLabTestByIdRequest, getLabTestByIdSuccess, getLabTestByIdFailure, resetGetLabTestById,
    searchLabTestRequest, searchLabTestSuccess, searchLabTestFailure, resetSearchLabTest,
    putLabTestRequest, putLabTestSuccess, putLabTestFailure, resetPutLabTest,
    deleteLabTestRequest, deleteLabTestSuccess, deleteLabTestFailure, resetDeleteLabTest,
    getLabTestFormulasRequest, getLabTestFormulasSuccess, getLabTestFormulasFailure, resetGetLabTestFormulas,
} = slice.actions;

export default slice.reducer;
